import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import { Row, Form } from 'antd';
import EditForm from '../../../../components/EditForm';
import {
  ButtonCancelar,
  ButtonSalvar,
  DivButtons,
  DivItems,
} from '../../../../components/EditForm/styles';
import { EditorContext } from '../../EditorContext/editorContext';
import { foneMask, dateMask } from '../../../../helpers/helpersEditForm';
import { getEstadosList } from '../../../../services/estado';
import {
  enviarDadosPessoa,
  getEnderecoForm,
  getPayloadPFPJ,
  getRNTRCForm,
} from '../Helpers/helpers';

export default function InfoProprietarioEdicao({
  proprietario,
  setReadOnly,
  carregarSolicitacaoAtual,
  setSpinning,
}) {
  const [form] = Form.useForm();
  const { setLockButton } = useContext(EditorContext);
  const [listUF, setListUF] = useState([]);

  const initialState = async () => {
    try {
      const response = await getEstadosList();
      setListUF(response.items);
    } catch (error) {}
  };

  useEffect(() => {
    initialState();
  }, []);

  const salvarEdicao = async form => {
    setLockButton(false);
    setReadOnly(true);

    const payload = getPayloadPFPJ(proprietario, form, true);

    return enviarDadosPessoa(
      setSpinning,
      carregarSolicitacaoAtual,
      setReadOnly,
      payload
    );
  };

  const handleCancel = () => {
    setReadOnly(true);
    setLockButton(false);
  };

  let propPF = [
    {
      label: 'Nome',
      nome: 'nome',
      width: '98.7%',
      initialValue: proprietario?.pessoaFisicaCadastro?.nome || null,
    },
    {
      label: 'CPF',
      nome: 'cpf',
      width: '32%',
      initialValue:
        proprietario?.pessoaFisicaCadastro?.cpf?.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/g,
          '$1.$2.$3-$4'
        ) || null,
      bloqueado: true,
      border: '1px solid #EFEFEF',
    },
    {
      label: 'Contato',
      nome: 'telefone',
      width: '32%',
      initialValue: proprietario?.telefone || null,
      onChange: e => foneMask(e.target.value, form, 'telefone'),
    },
    {
      label: 'Nome da Mãe',
      nome: 'nomeMae',
      width: '32%',
      initialValue: proprietario?.pessoaFisicaCadastro?.nomeMae || null,
    },
    {
      label: 'Nome do Pai',
      nome: 'nomePai',
      width: '32%',
      initialValue: proprietario?.pessoaFisicaCadastro?.nomePai || null,
    },
    {
      label: 'Nº id. do trabalhador (NIT)',
      nome: 'numeroPIS',
      width: '32%',
      initialValue: proprietario?.pessoaFisicaCadastro?.numeroPIS || null,
    },
  ];

  propPF = getRNTRCForm(form, propPF, proprietario?.proprietarioCadastro);

  propPF = getEnderecoForm(propPF, proprietario?.dadosEndereco, listUF);

  let propPJ = [
    {
      label: 'Nome Fantasia',
      nome: 'nomeFantasia',
      width: '98.7%',
      initialValue: proprietario?.pessoaJuridicaCadastro?.nomeFantasia || null,
    },
    {
      label: 'Razão Social',
      nome: 'razaoSocial',
      width: '98.7%',
      initialValue: proprietario?.pessoaJuridicaCadastro?.razaoSocial || null,
    },
    {
      label: 'CNPJ',
      nome: 'cnpj',
      width: '32%',
      initialValue: proprietario?.pessoaJuridicaCadastro?.cnpj || null,
      bloqueado: true,
      border: '1px solid #EFEFEF',
    },
    {
      label: 'Insc. Estadual',
      nome: 'inscEstadual',
      width: '32%',
      initialValue:
        proprietario?.pessoaJuridicaCadastro?.inscricaoEstadual || null,
    },
    {
      label: 'Telefone',
      nome: 'telefone',
      width: '32%',
      initialValue: proprietario?.telefone || null,
      onChange: e => foneMask(e.target.value, form, 'telefone'),
    },
  ];

  propPJ = getRNTRCForm(form, propPJ, proprietario?.proprietarioCadastro);

  propPJ = getEnderecoForm(propPJ, proprietario?.dadosEndereco, listUF);

  return (
    <Row
      justify="space-between"
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        marginTop: 32,
      }}
    >
      <Form form={form} layout="vertical" onFinish={form => salvarEdicao(form)}>
        {proprietario?.pessoaFisicaCadastro?.cpf ? (
          <DivItems>
            {propPF.map(item => (
              <EditForm
                key={item.nome}
                item={item}
                form={form}
                list={item.list}
              />
            ))}
          </DivItems>
        ) : (
          <DivItems>
            {propPJ.map(item => (
              <EditForm
                key={item.nome}
                item={item}
                form={form}
                list={item.list}
              />
            ))}
          </DivItems>
        )}

        <DivButtons>
          <Form.Item>
            <ButtonCancelar onClick={() => handleCancel()}>
              Cancelar
            </ButtonCancelar>
          </Form.Item>
          <Form.Item>
            <ButtonSalvar>Salvar</ButtonSalvar>
          </Form.Item>
        </DivButtons>
      </Form>
    </Row>
  );
}
